/**
 * Liste blanche des fonctions globales appelables depuis un attribut `data-on-*` (voir InlineActions.ts).
 * Générée à partir des gabarits (shell.html, views.html, chaînes de contrôleurs) ; le test
 * tests/security/InlineActionsCsp.test.ts échoue si un gabarit référence un nom absent de cette liste.
 */
export const INLINE_ACTION_NAMES = [
  'activerLicenceDepuisChamp',
  'addLigneManuelle',
  'annulerMarquageIRPP',
  'appliquerConvention',
  'applyAppUpdate',
  'applyUsbManifestDepuisChamp',
  'archiverStcDepuisConformite',
  'calculerPaie',
  'changePeriode',
  'checkAppUpdate',
  'closeSidebar',
  'cloturerExerciceCompta',
  'cloturerPeriodeCompta',
  'deactivateLicenceDevice',
  'deleteCoffreDoc',
  'deverrouillerPeriodeCompta',
  'doLogout',
  'downloadSaisieCsvTemplate',
  'downloadSalarieCsvTemplate',
  'enregistrerDPO',
  'enregistrerEcritureManuelle',
  'enregistrerRI',
  'enregistrerRapportGestion',
  'envoyerBulletins',
  'exportAD01',
  'exportAudit',
  'exportBackup',
  'exportBulletinsCSV',
  'exportCNAMGS',
  'exportCNSS',
  'exportCnamgsMensuel',
  'exportComptabiliteCSV',
  'exportComptabiliteOHADA',
  'exportDAS2',
  'exportDGI',
  'exportDeclarationTVA',
  'exportEtvaXml',
  'exportFEC',
  'exportReversementIRPP',
  'exportSalariesCSV',
  'exportSyntheseCSV',
  'exporterSaisie',
  'filterUsers',
  'genererAttestation',
  'genererDAS',
  'genererEcrituresPaie',
  'genererISAUI',
  'genererISPUI',
  'genererMD2DUI',
  'genererProvisionsExercice',
  'genererReserveLegaleUI',
  'gotoCurrentMonth',
  'gotoOffsetMonth',
  'handleFileUpload',
  'importBackup',
  'importLicenceFile',
  'importerSaisie',
  'imprimerRI',
  'imprimerRapportGestion',
  'inventaireAnnuel',
  'marquerReversementIRPP',
  'navigate',
  'openAGModal',
  'openActivePrivacyPolicy',
  'openCdcModal',
  'openCongeModal',
  'openCongeSelfModal',
  'openConventionModal',
  'openDemandeRGPDModal',
  'openDistributionModal',
  'openDtsModal',
  'openEvaluationModal',
  'openExerciceModal',
  'openFactureModal',
  'openFraisModal',
  'openImmoAnModal',
  'openImmoComptableModal',
  'openImportSalaries',
  'openOffreModal',
  'openSalarieModal',
  'openSanctionModal',
  'openStockModal',
  'openSuspensionModal',
  'openTiersModal',
  'openTraitementModal',
  'openUserMenu',
  'openUserModal',
  'openVehiculeModal',
  'ouvrirReglagesComptables',
  'passerDotationsImmo',
  'pickUsbUpdate',
  'printAllBulletins',
  'printSelectedBulletins',
  'purgeDemoERP',
  'rapprocherTous',
  'renderAnaBudget',
  'renderAnaSIG',
  'renderBalance',
  'renderCentreQualite',
  'renderCoffrefort',
  'renderConformite',
  'renderEtatsFinanciers',
  'renderGrandLivre',
  'renderRapportGestion',
  'renderSTCSalarie',
  'renewLicenceNow',
  'resetAll',
  'resetEcritureManuelle',
  'resetPlanComptable',
  'resetRapprochements',
  'resetStcConfig',
  'resetTiersInstitutionnels',
  'saveDevises',
  'saveEntreprise',
  'saveModulesSelection',
  'savePlanComptable',
  'saveStcConfig',
  'saveTiersInstitutionnels',
  'seedAnalytiqueMultiExercices',
  'seedCentresAnalytiquesDemo',
  'seedDemoData',
  'seedDemoEmployees',
  'seedERPData',
  'seedERPHistorique',
  'selectAllModules',
  'setPatenteForfait',
  'setPeriode',
  'setPeriodeDepuisSelect',
  'setProfilFiscal',
  'setSystemeComptable',
  'setTiersTab',
  'setUsersRoleFilter',
  'simulerIRVM',
  'switchAnaTab',
  'switchTab',
  'switchView',
  'syncNow',
  'toggle13e',
  'toggleAllBulletinsSelection',
  'toggleNavGroup',
  'toggleSidebar',
  'upgradeToLatestRelease',
  'validerBulletins',
] as const;
